var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"ring-chart-card"},[_c('div',{staticClass:"chart-title"},[_vm._v("债权统计(共"+_vm._s(_vm.total)+"个)")]),_c('div',{ref:"chart",staticClass:"chart-wrapper"})])}
var staticRenderFns = []

export { render, staticRenderFns }